import { h } from "preact";
import copenhagenPhoto from "../images/celina-cope.JPG";
import "./corner_styles.css";

export default function LearningPage() {
  return (
    <main class="corner-page content-page narrow-page learning-page">
      <section class="learning-lede">
        <p class="eyebrow">A little more about me</p>
        <h1>The less-resume version of me</h1>
        <p class="page-intro">I studied Computer Science at the University of Notre Dame and now work as a software engineer at PayPal. That’s probably the version of me LinkedIn would tell you about.</p>
        <p class="page-intro learning-second-intro">This page is about everything else.</p>
      </section>

      <div class="about-sections">
        <section data-scroll-reveal>
          <p class="eyebrow">How I accidentally became a software engineer</p>
          <h2>The feeling I've been chasing ever since...</h2>
          <p>I kind of stumbled upon my interest in Computer Science in high school. I figured coding was a useful skill to have, I enjoyed the intro class, and my best friend was taking AP Comp Sci, so I signed up too.</p>
          <p>Little did I know I would have to spend my free periods in my teacher’s classroom (shoutout Mr.Gillespie) trying to figure out why my code wouldn’t work. When it finally did though, it was such a rush. I’ve been chasing that feeling ever since.</p>
          <p>That’s still my favorite part of engineering. Writing code is fun, but the moment where something finally clicks--that’s what keeps me coming back.</p>
        </section>

        <section data-scroll-reveal>
          <p class="eyebrow">Outside of work</p>
          <h2>The other stuff</h2>
          <p>Outside of work, I spend an unreasonable amount of time learning things that don’t have much to do with my job. Lately that’s been guitar, French & Spanish, reading several books at once, lifting, and cooking (avid multitasker if you couldn't already tell).</p>
          <p>I also love traveling. It's probably the fastest way I've found to realize how much I still don't know about the world.</p>
        </section>

        <section data-scroll-reveal>
          <p class="eyebrow">How this website got out of hand</p>
          <h2>Oops</h2>
          <p>I originally built this website while trying to get my first job out of college. After I got hired, I asked one of the people who interviewed me if they even looked at it. They hadn’t. Womp womp (still got the job though).</p>
          <p>Somewhere along the way, this stopped being a portfolio and started becoming a little corner of the internet that’s just mine: a place to build things, experiment with web development, and occasionally write things down before I forget them.</p>
          <p>During my internship at Apple, one of my roommates worked on the apple.com team. I became fascinated by how software could present software--not just what a product does, but how it feels to experience it. I probably spent an unreasonable amount of time scrolling through product pages (and on youtube) just to figure out how they worked.</p>
          <p>I'd like to think I’m more than just a resume--at least here I’m also a bunch of HTML.</p>
          <p>Thanks for stopping by.</p>
        </section>
      </div>
      <figure class="me-photo" data-scroll-photo><img src={copenhagenPhoto} alt="Celina in Copenhagen, Denmark" /><figcaption>Copenhagen, Denmark</figcaption></figure>
    </main>
  );
}
